module.exports = __webpack_public_path__ + "img/ring_g_0_null_0.96ad4d11.png";